var map = {
	"./cs.json": 1064,
	"./da.json": 1065,
	"./de.json": 1066,
	"./en.json": 1067,
	"./et.json": 1068,
	"./fi.json": 1069,
	"./fm.json": 1070,
	"./fr.json": 1071,
	"./it.json": 1072,
	"./lt.json": 1073,
	"./lv.json": 1074,
	"./nl.json": 1075,
	"./no.json": 1076,
	"./pl.json": 1077,
	"./ru.json": 1078,
	"./sv.json": 1079,
	"./uk.json": 1080,
	"./zh.json": 1081
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1063;